export default "__VITE_ASSET__BWiAXbCO__"